import Vue from 'vue'
import Progress from './progress.vue'
import { enable_forests_form, enable_generic_form, enable_icbc_form, enable_bcas_form } from './script'

const ERROR = "An error occurred, and your files have not been uploaded. Please check the form and try again.";


function buildFormData(form) {
  let formData = new FormData(form);
  formData.append('ajax', true);

  return formData;
}

function startUpload(formData, {onProgress, onComplete, onError}){
  let xhr = new XMLHttpRequest();
  xhr.open('POST', '.', true);
  xhr.setRequestHeader("Cache-Control", "no-cache");

  xhr.addEventListener('load', onComplete(xhr));
  (xhr.upload || xhr).addEventListener('progress', onProgress(xhr));
  (xhr.upload || xhr).addEventListener('error', onError(xhr));
  xhr.send(formData);

}


function renderProgressButton(selector) {
  let submitButton = new Vue(Progress);
  submitButton.$mount(selector);
  return submitButton;
}

export default function(form) {
  if(!form){
    return
  }

  let progressDisplay = renderProgressButton('#submit-el');

  let onBeforeUnload = (e) => {
    let msg = "Leaving the page will cancel your upload. Really leave page?";
    e.returnValue = msg;
    return msg;
  };

  let onProgress = (xhr) => (e) => {
    progressDisplay.progress = (e.loaded / e.total) * 100;
  };

  let onComplete = (xhr) => (e) => {
    progressDisplay.progress = 0;

    try{
      let response = JSON.parse(xhr.responseText);
      if (response.status === "error") {
        progressDisplay.errorMessage = ERROR;
        return
      }
    } catch(_) { }

    if (xhr.status === 200) {
      window.removeEventListener('beforeunload', onBeforeUnload);
      window.location.href = "/thanks/";
    }
  };

  let onError = (xhr) => (e) => {
    progressDisplay.progress = 0;
    progressDisplay.errorMessage = ERROR;
  }

  let onSubmit = (e) => {
    e.preventDefault();

    // Mount unload confirmation listener
    window.addEventListener('beforeunload', onBeforeUnload);

    progressDisplay.progress = 0.01;
    progressDisplay.errorMessage = null;

    let formData = buildFormData(form);
    startUpload(formData, {onProgress, onComplete, onError});
    return false;
  };


  // Attach legacy validators
  if (form.classList.contains('bcas')) {
    enable_bcas_form(form, (_, e) => onSubmit(e));
  } else if (form.classList.contains('icbc')) {
    enable_icbc_form(form, (_, e) => onSubmit(e));
  } else if (form.classList.contains('forests')) {
    enable_forests_form(form, (_, e) => onSubmit(e));
  } else if (form.classList.contains('generic')) {
    enable_generic_form(form, (_, e) => onSubmit(e));
  } else {
    form.addEventListener('submit', onSubmit);
  }

}



// WEBPACK FOOTER //
// ./src/form.js